module.exports = __webpack_public_path__ + "img/暂无消息.11f01230.svg";